import React, { useState } from 'react';
import { Button, Modal, Form, Input, InputNumber, Select, Checkbox, Tooltip, Typography, message, DatePicker } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { dateFormat } from '../utils';
import { composeSelectOptions } from '../utils/ComponentUtils';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

function UpdateSeason(props) {
    // console.warn('props.season:', props.season);
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const { t } = useTranslation();

    function toggleModal() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        setIsActive(false);
        form.resetFields();
    }

    function onFinish(values) {
        form.validateFields({ validateOnly: true })
        .then(async () => {
            const season = props.season;
            const stringStartDate = values.startDate.format('YYYY-MM-DDTHH:mm:ssZ')
            const stringEndDate = values.endDate.format('YYYY-MM-DDTHH:mm:ssZ')
            // values.date = stringDate
            season.name = values.name;
            season.startDate = stringStartDate;
            season.endDate = stringEndDate;
            season.scheduledStages = values.scheduledStages;
            season.bestStages = values.bestStages;
            season.rankingBonus = values.rankingBonus;
            season.rankingBonusCap = values.rankingBonusCap;
            if (values.rankingBonus === false) {
                season.rankingBonusCap = 0;
            }

            //console.warn('Form values not valid!', values);

            const response = await fetch(api.seasons().update(season.id).href, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Setting.getToken(),
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(season) // body data type must match "Content-Type" header
            })
            .then((data) => data.json())

            if (response.errorMsg === "") {
                window.location.reload(false);
            } else {
                messageApi.error("You do not have the permission to edit this tournament status! Check the inserted infos.");
            }
        })
        .catch((errorInfo) => {
            // console.warn('errorInfo:', errorInfo);
            messageApi.error("Please compile all required fields of the form!");
        })
    }

    //TODO: add isDone value to initialValues.
    return(
            <div>
                {contextHolder}
                <Modal title={t('seasons.update')} open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} maskClosable={false} cancelText="Cancel" okText="Update">
                    <Form form={form} onFinish={onFinish} initialValues=
                    {{ 
                        "name": props.season.name, 
                        "startDate": dayjs(props.season.startDate), 
                        "endDate": dayjs(props.season.endDate), 
                        "scheduledStages": props.season.scheduledStages, 
                        "bestStages": props.season.bestStages, 
                        "rankingBonus": props.season.rankingBonus,
                        "rankingBonusCap": props.season.rankingBonusCap
                    }}
                    >
                        <Form.Item label={t('seasons.labelName')} name="name">
                            <Input placeholder="Name" />
                        </Form.Item>
                        <Form.Item label={t('seasons.startDate')} name="startDate">
                            <DatePicker format="DD/MM/YYYY" />
                        </Form.Item>
                        <Form.Item label={t('seasons.endDate')} name="endDate">
                            <DatePicker format="DD/MM/YYYY" />
                        </Form.Item>
                        <Form.Item 
                        label={t('stages.total')} 
                        tooltip="Put the number of expected stages you will schedule in the season."
                        name="scheduledStages" 
                        rules={[{ required: true, message: t('common.requiredField') }]}
                        >
                            <InputNumber placeholder={t('stages.total')} style={{ width: '100%' }} min={5}/>
                        </Form.Item>
                        <Form.Item 
                        label={t('stages.valid')} 
                        tooltip="The number of valid stages to count point from. For each player the worst results will be excluded"
                        name="bestStages" 
                        rules={[{ required: true, message: t('common.requiredField') }]}
                        >
                            <InputNumber placeholder={t('stages.valid')} style={{ width: '100%' }} min={5}/>
                        </Form.Item>
                        <Form.Item
                            label={t('seasons.participationBonus')}
                            tooltip="Assign a bonus for stage participation to the players?"
                            name="rankingBonus"
                            valuePropName="checked"
                        >
                            <Checkbox />
                        </Form.Item>
                        <Form.Item 
                            label={t('seasons.bonusCap')} 
                            tooltip="Set a cap for the participation bonus points"
                            name="rankingBonusCap"
                            >
                            <InputNumber placeholder="0" style={{ width: '100%' }} min={0}/>
                        </Form.Item>
                    </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal}>
                   {t('seasons.update')}
                </Button>
            </div>
    )
}

export default UpdateSeason;